export default class Statuses {
    static statuses = [
        {
            label : 'Published',
            value : 'active'
        },
        {
            label : 'Unpublished',
            value : 'inactive'
        },
        {
            label : 'Recently Added',
            value : 'new'
        }
    ]

    static label(value) {
        return Statuses.statuses.find(level => level.value === value)?.label;
    }
}